import { ApiPort } from "$ACTIONS/TLCAPI";
import { get } from "$ACTIONS/TlcRequest";

function _removeProtocal(url) {
  if (url.indexOf('https://')===0) {
    url = url.replace('https://', '//');
  } else if (url.indexOf('http://')===0) {
    url = url.replace('http://', '//');
  }
  return url;
}

//
export async function getExternalPromotions() {
  const res = await get(ApiPort.GETExternalPromotions)
  return res;
}

function _pickImagePathByName(res, targetName) {
  let ret;
  if (res && res.isSuccess && res.result && Array.isArray(res.result.promotionItems)) {
    ret = res.result.promotionItems.find(v => v.name===targetName);
  }
  return ret && _removeProtocal(ret.imagePath);
}
export function getBBUProfileImagePath(res) { return _pickImagePathByName(res, 'BBU-Profile') }
export function getBBUDepositImagePath(res) { return _pickImagePathByName(res, 'BBU-Deposit') }
export function getBBUWithDrawalImagePath(res) { return _pickImagePathByName(res, 'BBU-Withdrawal') }
export function getBullstreetProfileImagePath(res) { return _pickImagePathByName(res, 'Bullstreets-Profile') }
export function getBullstreetDepositImagePath(res) { return _pickImagePathByName(res, 'Bullstreets-Deposit') }
export function getBullstreetWithdrawalImagePath(res) { return _pickImagePathByName(res, 'Bullstreets-Withdrawal') }

//
export async function getExternalPromotionLink(promoName) {
  if (!promoName) {
    return;
  }
  let qs = promoName ? '&promotionName=' + promoName : '';
  const res = await get(ApiPort.GETExternalPromotionLink + qs)
  return res;
}
function _pickExternalPromotionLink(res) {
  return res && res.isSuccess ? res.result : '';
}
export async function getExternalBBUPromotionLink() {
  return _pickExternalPromotionLink(
      await getExternalPromotionLink('BBU'))
}
export async function getExternalBullstreetPromotionLink() {
  return _pickExternalPromotionLink(
      await getExternalPromotionLink('Bullstreet'))
}
